var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.items.length)?_c('ul',{staticClass:"field__errorList"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"field__error"},[_vm._v(" "+_vm._s(item)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }